import { render, staticRenderFns } from "./CreateVat.vue?vue&type=template&id=559fb7c8"
import script from "./CreateVat.vue?vue&type=script&lang=js"
export * from "./CreateVat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports